import { Box, Skeleton } from "@mui/material";

const SKELETON_ROW_COUNT = 6;

const skeletonRowSx = {
  display: "flex",
  alignItems: "flex-start",
  py: 1.25,
  px: 2,
  gap: 1,
};

function CampaignOptionSkeletonRow() {
  return (
    <>
      <Skeleton
        variant="rounded"
        width={18}
        height={18}
        animation="wave"
        sx={{ borderRadius: 0.5, mt: 0.25, flexShrink: 0 }}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.75 }}>
          <Skeleton variant="circular" width={8} height={8} animation="wave" />
          <Skeleton variant="text" width="72%" height={20} animation="wave" />
        </Box>
        <Skeleton variant="text" width="48%" height={16} animation="wave" sx={{ ml: 2 }} />
      </Box>
    </>
  );
}

/** Skeleton list shown inside campaign Autocomplete paper while campaigns load. */
export function CampaignAboCampaignSelectSkeletonList() {
  return (
    <Box
      role="status"
      aria-label="Loading campaigns"
      sx={{ maxHeight: 280, overflow: "hidden", py: 0.5 }}
    >
      {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
        <Box key={`campaign-skeleton-${index}`} sx={skeletonRowSx}>
          <CampaignOptionSkeletonRow />
        </Box>
      ))}
    </Box>
  );
}

export default CampaignAboCampaignSelectSkeletonList;
